import Vue from 'vue';
import _get from 'lodash/get';
import Component from 'vue-class-component';
import { IMenuType } from '@/types/menu';

// You can declare mixins as the same style as components.
@Component
export class MenuMixins extends Vue {
  _get(_, __, ___) {
    return _get(_, __, ___);
  }

  mapTypeToString = (type: IMenuType) => {
    if (type === 'html') {
      return '文本页';
    }
    if (type === 'list') {
      return '列表页';
    }
    if (type === 'link') {
      return '链接页';
    }
    if (type === 'vain') {
      return '父层';
    }
  };

  mapTemplateToString(template: string) {
    if (template === 'character1') {
      return '领导模板';
    }
    if (template === 'character2') {
      return '教师模板';
    }
    if (template === 'character3') {
      return '行政机构专用模板';
    }
    if (template === 'character4') {
      return '人员模板';
    }
    if (template === 'article1') {
      return '文字模板';
    }
    if (template === 'article2') {
      return '图文模板';
    }
    if (template === 'article3') {
      return '作品列表模板';
    }
    return '';
  }
}
